import { BsDatepickerViewMode } from '../models/index';

export function canSwitchMode(mode: BsDatepickerViewMode): boolean {
  return true;
}



// WEBPACK FOOTER //
// ./.tmp/datepicker/engine/view-mode.ts